import type {
  ExtendWithOption,
  ExtensionMetric,
  FunnelSection,
  FunnelStageMetric,
} from 'containers/user/critical-elements-monitoring/critical-elements-monitoring.types';

export type FunnelCardRowItem =
  | { kind: 'stage'; key: string; stage: FunnelStageMetric }
  | { kind: 'extension'; key: string; extension: ExtensionMetric }
  | { kind: 'extension-upsell'; key: string; extensionType: ExtendWithOption };

export const buildFunnelCardRow = (
  funnel: FunnelSection,
  selectedUnentitledExtensions: readonly ExtendWithOption[] = []
): FunnelCardRowItem[] => {
  const extensionByType = new Map(
    funnel.extensions.map((extension) => [extension.type, extension])
  );
  const stageByKey = new Map(
    funnel.stages.map((stage) => [stage.stageKey, stage])
  );

  const items: FunnelCardRowItem[] = [];

  const pushExtension = (type: ExtendWithOption): void => {
    const extension = extensionByType.get(type);

    if (extension) {
      items.push({ kind: 'extension', key: type, extension });

      return;
    }

    if (selectedUnentitledExtensions.includes(type)) {
      items.push({ kind: 'extension-upsell', key: type, extensionType: type });
    }
  };

  const pushStage = (stageKey: FunnelStageMetric['stageKey']): void => {
    const stage = stageByKey.get(stageKey);

    if (stage) items.push({ kind: 'stage', key: stage.stageKey, stage });
  };

  pushExtension('prospect');
  pushStage('inquiry');
  pushStage('application');
  pushStage('admit');
  pushExtension('financial-aid');
  pushStage('netDeposit');
  pushExtension('retention');

  return items;
};
